if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const cartItemsElement = document.getElementById('main-cart-items');
      const cartFooterElement = document.getElementById('main-cart-footer');
      if (this.cart) {
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        // On the cart page also refresh the on-page cart list + footer so adding
        // from a product card below updates the cart without a full reload.
        if (cartItemsElement && cartItemsElement.dataset.id) sections.push(cartItemsElement.dataset.id);
        if (cartFooterElement && cartFooterElement.dataset.id) sections.push(cartFooterElement.dataset.id);
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          if (cartItemsElement) this.renderCartPageSections(response);

          this.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              response,
              variantId: response.variant_id || response.id
            }
          }));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    renderCartPageSections(response) {
      if (!response.sections) return;
      ['main-cart-items', 'main-cart-footer'].forEach((id) => {
        const element = document.getElementById(id);
        if (!element || !element.dataset.id) return;
        const html = response.sections[element.dataset.id];
        if (!html) return;
        const target = element.querySelector('.js-contents') || element;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('.js-contents');
        if (source) target.innerHTML = source.innerHTML;
      });
      // Let cart-deferred.js re-render set-aside rows and re-evaluate is-empty.
      document.dispatchEvent(new CustomEvent('cart:sections-rendered'));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
